import React from 'react';
import ChatBox from './ChatBox'; 

function App() {
  return (
    <div style={{ padding: 20, textAlign: 'center' }}>
      <ChatBox />
    </div>
  );
}

export default App;
